export default __webpack_public_path__ + "static/media/cover-pic2.14d53835.jpg";